import { CPR_AUTH, CPR_BROWSERID, FAF_AUTH, FAF_BROWSERID } from "../../../constant/Constants";
import axiosCall from "../../axiosCall";
import { resetSessionTiming } from "../../sessionManagement";



//Document List
export const fetchDocList = async ({ appData, prgData }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const data = {
        RequestDetails : {
            // RequestID : requestID,
             ServiceName : "ListDocument",
            //    RequestTime :requestTime,
              BrowserToken :browserID,
              Application : prgData,
             PortalID : appData.portalUserID
              },
             Application :{
                ApplicationID:appData.applicationID,
                 PortalType :'Partner',
                 "PortalUserDetails":{
                  "PortalUserID":appData.portalUserID,
                  "EmailAddress": appData.EmailAddress,
                  "PortalType": "Partner",
                  "ReferenceID": `E-${appData.ReferenceID}`,
                  "SubmissionChannel": "Partner"
              }
    
               }
    }
   
    const response = await axiosCall('post', `/Documents/v1/ListDocument/${prgData}?`, authorization, `BrowserID=${browserID}`, data, prgData);
    return { res: response.data, program: prgData }
}


// File Type Document download
export const fetchFileDocument = async ({ DocumentID, prgData, reqsData }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const data = {
        DocumentID:DocumentID.trim()
    }
   
    const response = await axiosCall('post', `/Documents/v1/DocumentDetails?`, authorization, `BrowserID=${browserID}`, data, prgData);
    return { res: response.data, program: prgData, secData: reqsData }
}



// Regenerate Document download
export const fetchFileRegenerateDocument = async ({ doc, prgData, reqsData }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const data = {
        "RequestDetails": {
            // "RequestID": requestID,
            "ServiceName": "ListDocument",
            // "RequestTime": requestTime,
            "BrowserToken":browserID,
            "Application" : prgData,
            "PortalID": doc.PortalID
          },        
        //   "CaseID": doc?.CaseID ? doc?.CaseID : '',
          "PreferredLanguage": doc.PreferredLanguage,
          "TemplateID": doc.RegenerateLetter,
          "PreferredContact": doc.PreferredContact,
          "ApplicationID" : doc.ApplicationID,
          "RegenerateLetter" : doc.RegenerateLetter
    }
   
    const response = await axiosCall('post', `/Documents/v1/RegenerateCorrespondence?`, authorization, `BrowserID=${browserID}`, data, prgData);
    return { res: response.data, program: prgData, secData: reqsData }
}


export const fetchUploadDocument = async ({ doc, prgData, reqsData }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const data = {
        ContactId:  doc.PatientID,
        PortalUserID: doc.PortalUserID,
        "SubmissionChannel": "Partner",
        "PortalUserDetails": {
            "EmailAddress": doc.EmailAddress,
            "PortalType": "Partner",
            "ReferenceID": `E-${doc.EIN}`,
            PortalUserID: doc.PortalUserID,
            "SubmissionChannel": "Partner"
        },
        ApplicationID: doc.Application_Id,
        CustomDragAndDropFiles: doc.Documents
    }
   
    const response = await axiosCall('post', `/Documents/v1/CreateDocument/${prgData}?`, authorization, `BrowserID=${browserID}`, data, prgData);
    return { res: response.data, program: prgData, secData: reqsData }
}